import { render } from "./unscheduledvisits.vue?vue&type=template&id=7ecf9c68"
import script from "./unscheduledvisits.vue?vue&type=script&lang=js"
export * from "./unscheduledvisits.vue?vue&type=script&lang=js"

import "./unscheduledvisits.vue?vue&type=style&index=0&id=7ecf9c68&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__